<div class="solictud-recibida">
  <div class="left">
    <img src="./assets/img/hombre-celular.png" alt="Solicitud recibida exitósamente" />
  </div>
  <div class="right">

    <!-- FORMULARIOS -->
    <h2 *ngIf="(codigo === '000')">
      Hemos recibido exitosamente tu solicitud N° {{solicitud}}, la cual será procesada en un plazo de {{plazo}} días hábiles.
    </h2>

    <h2 *ngIf="(codigo === '002')">
      Hemos recibido exitosamente tu doble solicitud N° {{solicitud}}, la cual será procesada en un plazo de {{plazo}} días.
    </h2>

    <h2 *ngIf="(codigo === 999)">
      Hemos recibido exitosamente tu solicitud N° {{solicitud}}, la cual será gestionada, y procesada con la autorización del cliente de la propiedad donde se realizó el abono del pago, en un plazo {{plazo}} de días.
    </h2>

    <h3 *ngIf="mensaje === 'AVISO CREADO CON EXITO CON SUSCRIPCION' ">
      ¡Gracias por suscribirte a<br>
      la boleta electrónica!*
    </h3>
    <p *ngIf="mensaje === 'AVISO CREADO CON EXITO CON SUSCRIPCION' ">
      **En el caso de que tu próxima boleta ya esté impresa y/o despachada, la suscripción electrónica se hará efectiva
      desde el próximo periodo de facturación.
    </p>

    <!-- TRACKING -->
    <h2 *ngIf="(codigo === 'INGRESADO')">
      Su solicitud N° {{solicitud}} se encuentra ingresada.
    </h2>
    <h2 *ngIf="(codigo === 'EN TRATAMIENTO')">
      Su solicitud Nº {{solicitud}}, está siendo gestionada por uno de nuestros asistentes.
    </h2>
    <h2 *ngIf="(codigo === 'FINALIZADO')">
      Su solicitud Nº {{solicitud}} ha finalizado correctamente
    </h2>
    <h2 *ngIf="(codigo === 'RECHAZADO')">
      Su solicitud Nº {{solicitud}} <br> se encuentra rechazada ya que no cuenta con toda la información necesaria para ser procesada. Favor ingresar nuevamente su solicitud.
      <!-- ya que no cuenta con toda la información necesaria para ser procesada. <br>
      Favor ingresar nuevamente su solicitud. -->
    </h2>

    
    <!-- PRE-VISUALIZACIÓN CONSTANCIA DE INGRESO -->
    <!-- <div class="constancia-preview" *ngIf="datosConstancia" style="margin-top: 30px; padding: 25px; background: #f8f9fa; border: 2px solid #004571; border-radius: 10px;">
      <h3 style="color: #004571; margin-bottom: 20px; text-align: center; font-size: 1.4em;">📋 Resumen de tu Solicitud</h3>
      
      <div class="datos-seccion" style="margin-bottom: 20px; padding: 15px; background: white; border-radius: 5px;">
        <h4 style="color: #ff6600; margin-bottom: 15px; border-bottom: 2px solid #ff6600; padding-bottom: 5px;">Datos del Solicitante</h4>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <p><strong>N° Cliente:</strong> {{datosConstancia.nCliente}}</p>
          <p><strong>RUT:</strong> {{datosConstancia.rut}}</p>
          <p><strong>Nombre:</strong> {{datosConstancia.nombre}}</p>
          <p><strong>Teléfono:</strong> {{datosConstancia.telefono}}</p>
          <p style="grid-column: 1 / -1;"><strong>Email:</strong> {{datosConstancia.email}}</p>
        </div>
      </div>

      <div class="datos-seccion" style="margin-bottom: 20px; padding: 15px; background: white; border-radius: 5px;">
        <h4 style="color: #ff6600; margin-bottom: 15px; border-bottom: 2px solid #ff6600; padding-bottom: 5px;">Tipo y Detalle de Solicitud</h4>
        <p><strong>Tipo:</strong> {{datosConstancia.tipoContacto}}</p>
        <p><strong>Proceso:</strong> {{datosConstancia.procesoNombre}}</p>
        <p *ngIf="datosConstancia.subprocesoNombre"><strong>Subproceso:</strong> {{datosConstancia.subprocesoNombre}}</p>
        <p style="margin-top: 10px;"><strong>Detalle:</strong></p>
        <p style="background: #f8f9fa; padding: 10px; border-left: 3px solid #ff6600; margin-top: 5px;">{{datosConstancia.detalle}}</p>
      </div>

      <div class="datos-seccion" *ngIf="datosConstancia.esReclamoPorCobro" style="margin-bottom: 20px; padding: 15px; background: #fff3cd; border: 2px solid #ff6600; border-radius: 5px;">
        <h4 style="color: #ff6600; margin-bottom: 15px; border-bottom: 2px solid #ff6600; padding-bottom: 5px;">💰 Reclamo por Cobro</h4>
        <p><strong>Monto Reclamado:</strong> ${{datosConstancia.montoReclamado}}</p>
        <p><strong>Concepto:</strong> {{datosConstancia.conceptoCobroNombre}}</p>
        <p *ngIf="datosConstancia.cargoReclamado"><strong>Cargo Reclamado:</strong> {{datosConstancia.cargoReclamado}}</p>
        <p *ngIf="datosConstancia.otroConceptoCobro"><strong>Especificación:</strong> {{datosConstancia.otroConceptoCobro}}</p>
      </div>

      <div class="datos-seccion" style="margin-bottom: 20px; padding: 15px; background: white; border-radius: 5px;">
        <h4 style="color: #ff6600; margin-bottom: 15px; border-bottom: 2px solid #ff6600; padding-bottom: 5px;">Medio de Respuesta</h4>
        <p><strong>Recibirá respuesta vía:</strong> {{datosConstancia.medioEnvioNombre}}</p>
        <div *ngIf="datosConstancia.callePostal">
          <p style="margin-top: 10px;"><strong>Dirección Postal:</strong></p>
          <p>{{datosConstancia.callePostal}} {{datosConstancia.numeroPostal}}, {{datosConstancia.comunaPostal}}</p>
        </div>
      </div>

      <div class="datos-seccion" *ngIf="datosConstancia.documentosAdjuntos && datosConstancia.documentosAdjuntos.length > 0" style="margin-bottom: 20px; padding: 15px; background: white; border-radius: 5px;">
        <h4 style="color: #ff6600; margin-bottom: 15px; border-bottom: 2px solid #ff6600; padding-bottom: 5px;">📎 Documentos Adjuntos ({{datosConstancia.documentosAdjuntos.length}})</h4>
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li *ngFor="let doc of datosConstancia.documentosAdjuntos; let i = index" style="padding: 12px; background: #f8f9fa; margin-bottom: 8px; border-left: 3px solid #004571; word-wrap: break-word; overflow-wrap: break-word; display: block; clear: both;">
            <div style="display: flex; flex-direction: column; gap: 4px;">
              <strong style="display: block; color: #004571; font-size: 0.95em;">Documento {{i + 1}}:</strong>
              <span style="display: block; padding-left: 15px; line-height: 1.4;">{{doc.detalle || 'Sin descripción'}}</span>
              <span style="display: block; padding-left: 15px; color: #666; font-size: 0.85em; font-style: italic; line-height: 1.3;">📄 {{doc.fileName}}</span>
            </div>
          </li>
        </ul>
      </div>

      <div style="text-align: center; margin-top: 25px; padding-top: 20px; border-top: 2px dashed #ccc;">
        <p style="color: #004571; font-size: 0.95em; margin-bottom: 15px;">
          <strong>Importante:</strong> Guarda este número de solicitud <span style="color: #ff6600; font-size: 1.2em;">{{solicitud}}</span> para futuras consultas.
        </p>
        <button (click)="imprimirConstancia()" class="btn btn-imprimir" style="padding: 10px 25px; background-color: #004571; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold; margin-right: 10px;">
          🖨️ Imprimir Constancia
        </button>
      </div>
    </div> -->

    <!-- SECCIÓN DE DESCARGA DE CONSTANCIA -->
    <div class="constancia-container" *ngIf="constanciaDisponible" style="margin-top: 25px; padding: 20px; background: #f0f7ff; border: 2px solid #004571; border-radius: 10px;">
      <h3 style="color: #004571; margin-bottom: 10px; font-size: 1.1em;">📋 Constancia de Ingreso de Reclamo</h3>
      <p style="color: #555; font-size: 0.95em; margin-bottom: 15px;">
        Puede descargar o visualizar la constancia de su solicitud N° <strong style="color: #ff6600;">{{solicitud}}</strong>.
      </p>

      <!-- Mensaje de error -->
      <div *ngIf="errorConstancia" style="padding: 10px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 5px; margin-bottom: 15px; color: #856404;">
        ⚠️ No fue posible obtener la constancia en este momento. Por favor, intente nuevamente más tarde.
      </div>

      <div style="display: flex; gap: 10px; flex-wrap: wrap;">
        <button
          (click)="abrirConstancia()"
          [disabled]="descargandoConstancia"
          style="padding: 10px 20px; background-color: #004571; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold; font-size: 0.9em;">
          <span *ngIf="!descargandoConstancia">👁️ Ver Constancia</span>
          <span *ngIf="descargandoConstancia">Cargando...</span>
        </button>
        <button
          (click)="descargarConstancia()"
          [disabled]="descargandoConstancia"
          style="padding: 10px 20px; background-color: #004571; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold; font-size: 0.9em;">
          <span *ngIf="!descargandoConstancia">⬇️ Descargar Constancia</span>
          <span *ngIf="descargandoConstancia">Cargando...</span>
        </button>
      </div>
    </div>

    <input type="button" value="FINALIZAR" class="btn btn-finalizar" [routerLink]="['/home']">
  </div>
</div>
